import Key from "csi/core/Key";
import Widget from "csi/table/Widget";
import declare from "dojo/_base/declare";
import { C8AttributeKey } from "src/c8-platform/type/value";
import Sourcing from "./main";

const SRMSupplierAllocationTable = declare(Widget, {
	/**
	 * @override
	 * Don't render SupplierFactory heading on Supplier SR subtypes
	 */
	onViewResolveKeysToSkip(skipSet: Set<C8AttributeKey>): void { 
		const viewNode = this.getViewNode();

		if (Sourcing.isSubtypeSupplierSourced(viewNode?.SRSubtype)) {
			skipSet.add(Key.untypedKeyFromParts({
				id: "SRSupplierFactory",
				matrix: "SupplierAllocation",
				path: "Parent:SRMProducts/Child:SRMSupplierRequests",
			}));
		}
	},
});

export = SRMSupplierAllocationTable;